module.exports = __webpack_public_path__ + "img/etax-one-th.e7098d4.webp";